import type { Event } from '../types';

export const RefiDisqualifiedEventData = {
  NotInsuredOrExpired: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'NotInsuredOrExpired',
  } as Event<string>,
  UserIneligible: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'UserIneligible',
  } as Event<string>,
  CarIneligible: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'CarIneligible',
  } as Event<string>,
  NoCarLoan: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'NoCarLoan',
  } as Event<string>,
  NoMinNumberPayments: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'NoMinNumberPayments',
  } as Event<string>,
  HighEstimatedMileage: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'HighEstimatedMileage',
  } as Event<string>,
  LowGrossIncome: {
    eventAction: 'IsRefiQualified',
    eventLabel: 'LowGrossIncome',
  } as Event<string>,
};
